/**
 * RightPanel — 320px aside with Auth / Inbound / Outbound tabs.
 */
import React from 'react';
import { Pressable, ScrollView, StyleSheet, Text, View } from 'react-native';
import { colors, fontFamily, fontSize, fontWeight } from '../../theme';
import { useBridge } from '../../store/bridgeStore';
import AuthPanel from './panels/AuthPanel';
import InboundPanel from './panels/InboundPanel';
import OutboundPanel from './panels/OutboundPanel';

export default function RightPanel({ adapterId, vendorName }: { adapterId: string; vendorName: string }) {
  const { state, actions } = useBridge();
  const tab = state.rightTab;

  return (
    <View style={styles.aside}>
      <View style={styles.tabs}>
        <Tab label="Auth" active={tab === 'auth'} onPress={() => actions.setRightTab('auth')} />
        <Tab label="Inbound" active={tab === 'change'} onPress={() => actions.setRightTab('change')} />
        <Tab label="Outbound" active={tab === 'outbound'} onPress={() => actions.setRightTab('outbound')} />
      </View>
      <ScrollView style={{ flex: 1 }} contentContainerStyle={{ padding: 16 }}>
        {tab === 'auth' && <AuthPanel adapterId={adapterId} vendorName={vendorName} />}
        {tab === 'change' && <InboundPanel adapterId={adapterId} vendorName={vendorName} />}
        {tab === 'outbound' && <OutboundPanel adapterId={adapterId} vendorName={vendorName} />}
      </ScrollView>
    </View>
  );
}

function Tab({ label, active, onPress }: { label: string; active: boolean; onPress: () => void }) {
  return (
    <Pressable onPress={onPress} style={[styles.tab, active ? styles.tabActive : null]}>
      <Text style={[styles.tabText, active ? { color: colors.ink } as any : null]}>{label}</Text>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  aside: { width: 320, flexShrink: 0, borderLeftWidth: 1, borderLeftColor: colors.line, backgroundColor: colors.card, flexDirection: 'column', overflow: 'hidden' } as any,
  tabs: { flexDirection: 'row', borderBottomWidth: 1, borderBottomColor: colors.line, paddingHorizontal: 8 },
  tab: { paddingVertical: 9, paddingHorizontal: 14, borderBottomWidth: 2, borderBottomColor: 'transparent', marginBottom: -1, cursor: 'pointer' } as any,
  tabActive: { borderBottomColor: colors.ink },
  tabText: { fontFamily: fontFamily.sans, fontSize: fontSize.md, fontWeight: fontWeight.medium, color: colors.ink3 },
});
